import { useRef } from 'react';
import { FEATURE_FLAGS } from '../../account-configurations';
import useConfigMatch from '../../account-configurations/hooks/useConfigMatch';
import { usePermissions } from '../../authentication/hooks';

export const useMultiLayerDrawerEnabledOnce = () => {
    const isMultiLayerDrawerFFEnabled = useConfigMatch({ [FEATURE_FLAGS.MULTI_LAYER_DRAWER_ENABLED]: 'true' });
    const isMultiLayerDrawerPermissionsEnabled = usePermissions('MULTI_LAYER_DRAWER_ENABLED');
    const isDrawerEnabled = isMultiLayerDrawerFFEnabled || isMultiLayerDrawerPermissionsEnabled;

    const isMultiDrawerEnabledOnce = useRef(isDrawerEnabled);

    if (!isMultiDrawerEnabledOnce.current && isDrawerEnabled) {
        isMultiDrawerEnabledOnce.current = true;
    }

    return isMultiDrawerEnabledOnce.current;
};
